import React from "react";

const Java_startsWith = () => {
  return (
    <div>
      <h1>Java startsWith</h1>
      <p>This page provides explanations, examples, and common use-cases for Java startsWith in Java.</p>
    </div>
  );
};

export default Java_startsWith;
